export default __webpack_public_path__ + "static/media/Independent_J_Trix_ft_Projekt_AZ_&_5aumit_Official_Music_Video.f4e9c1f0.mp3";